import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useMaintenanceStore = defineStore("maintenance", () => {
  // State
  const isMaintenanceStatusLoadedState = ref<boolean>(false);
  const isMyJFUnderMaintenanceState = ref<boolean>(false);

  // Getters
  const isMyJFUnderMaintenance = computed(
    () => isMyJFUnderMaintenanceState.value,
  );
  const isMaintenanceStatusLoaded = computed(
    () => isMaintenanceStatusLoadedState.value,
  );

  // Actions
  const setIsMyJFUnderMaintenance = (underMaintenance: boolean) => {
    isMyJFUnderMaintenanceState.value = underMaintenance;
  };

  const setIsMaintenanceStatusLoaded = (loaded: boolean) => {
    isMaintenanceStatusLoadedState.value = loaded;
  };

  return {
    isMyJFUnderMaintenance,
    isMaintenanceStatusLoaded,
    setIsMyJFUnderMaintenance,
    setIsMaintenanceStatusLoaded,
  };
});
